/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React, { useState } from "react"
import { FlexContainer, colors, H5, Icon } from "@carrotfertility/carotene"
import { ChangeLocationModal } from "./ChangeLocationModal"
import styled from "styled-components"
import { Typography } from "@carrotfertility/carotene-core"
import { PiiText } from "services/tracking"
import { FormattedMessage } from "react-intl"

interface StyledButtonProps {
  open?: boolean
}
const StyledButton = styled.button<StyledButtonProps>`
  text-align: left;
  background: white;
  border-radius: 6px;
  display: block;
  width: 100%;
  padding: 12px 12px 16px 12px;
  cursor: pointer;
  border: ${(props) => (props.open ? `2px solid ${colors.base.carrotOrange}` : `2px solid white`)};
  &:focus-visible {
    border: ${`2px solid ${colors.base.carrotOrange}`};
    outline: none;
  }
  &:hover {
    border: ${`2px solid ${colors.base.carrotOrange}`};
  }
`

export function SidebarLocationPicker({ searchLocation }: { searchLocation: string }): JSX.Element {
  const [open, setOpen] = useState(false)

  return (
    <>
      <StyledButton
        open={open}
        onClick={() => {
          setOpen(true)
        }}
      >
        <Typography component={PiiText}>{searchLocation}</Typography>
        <FlexContainer sx={{ cursor: "pointer" }} gap="5.5px" alignItems="baseline">
          <H5 sx={{ fontWeight: "500", lineHeight: "21px", color: colors.base.carrotOrange }}>
            <FormattedMessage defaultMessage={`Change location`} />
          </H5>
          <Icon name={"rightCarrotSmall"} color={"carrotOrange"} size={"6px"} />
        </FlexContainer>
      </StyledButton>
      <ChangeLocationModal open={open} setOpen={() => setOpen(false)} />
    </>
  )
}
